module.exports = __webpack_public_path__ + "static/lathander-symbol-SCAG-568e3fdb57a6b38888378fc0f730dca2.png";